<!-- [1段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block">
      <div class="p-input-list-area01__block-item">
        <asw-airport-round id="roundtrip-airport-round" (switchEvent)="switch($event)">
          <asw-airport
            origin
            label="origin"
            [airportListParts]="airportListPartsFrom"
            [(selectedAirport)]="selectedOriginAirport"
            (changeEvent)="getOutputOriginAirport($event)"
            [airportFormControl]="this.originAirportControl"
            id="roundtrip-airport-from"
            #originAirportComponent
          ></asw-airport>
          <asw-airport
            destination
            [airportListParts]="airportListPartsTo"
            [(selectedAirport)]="selectedDestinationAirport"
            (changeEvent)="getOutputDestinationAirport($event)"
            [airportFormControl]="this.destinationAirportControl"
            id="roundtrip-airport-to"
            #destinationAirportComponent
          ></asw-airport>
        </asw-airport-round>
      </div>
    </div>
  </div>

  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <div class="p-input-list-area01__block-item-box">
          <asw-date-selector
            #departureAndReturnDateComponent
            [dateSelectorParts]="dateSelectorParts"
            (changeDate)="getOutputDepartureAndReturnDate($event)"
            id="roundtrip-date-selector-1"
            [dateForm]="this.departureAndReturnDateFormGroup"
          >
          </asw-date-selector>
        </div>

        <div class="p-input-list-area01__block-item-box p-input-list-area01__block-item-box--has-about-passenger">
          <!-- 運賃比較チェック削除 -->
        </div>
      </div>

      <div class="p-input-list-area01__block-item">
        <asw-passenger-selector
          [passengersCount]="this.passengersCount"
          [passengersErrorMsg]="information.passengersErrorMsg"
          [isEnabled]="this.isEnabled"
          [isInfantCountShow]="
            !this.isJapanOnlyFlag || this.posCountryCode === 'JP' || dcsMigrationDateStatus !== 'Before'
          "
          [isChild3To11]="this.isJapanOnlyFlag && this.posCountryCode !== 'JP' && dcsMigrationDateStatus === 'Before'"
          [isInfant0To1]="!oldDomesticAswSearchFlag"
          [dcsMigrationDateStatus]="dcsMigrationDateStatus"
          (apply$)="getOutputPassengerSelect($event)"
        ></asw-passenger-selector>
      </div>
    </div>
  </div>
</div>
<!-- //[1段目] -->

<!-- [option] -->
<div class="p-input-list-area02">
  <!-- [option 開閉ボタン] -->
  <div class="p-input-list-area02__head">
    <button
      #searchOptionButton
      type="button"
      id="roundtrip-button-1"
      class="c-option-btn01 js-drawer-options-btn"
      [ngClass]="{ ' is-open': isOpenSearchOption }"
      aria-controls="drawer-options"
      [attr.aria-expanded]="isOpenSearchOption"
      (click)="clickOptionOpen()"
      [innerHTML]="'label.transferconditionsOptionMenu.open' | staticMsg"
    ></button>
  </div>
  <!-- //[option 開閉ボタン] -->

  <div
    #drawerOptions
    id="drawer-options"
    class="p-input-list-area02__body js-drawer-options-body"
    [ngClass]="{ ' is-open': isOpenSearchOption }"
    aria-labelledby="roundtrip-button-1"
  >
    <div class="p-input-list-area02__item">
      <div class="p-input-list-area02__block p-input-list-area02__block--half">
        <!-- [option 左側] -->
        <div class="p-input-list-area02__block-item">
          <div class="p-input-list-area02__block-item-box">
            <h3 class="p-input-list-area02__block-item-title" [innerHTML]="'label.outwardPath' | staticMsg"></h3>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <h4 class="p-input-list-area02__block-item-lv2title" [innerHTML]="'labal.departureTime' | staticMsg"></h4>
            <asw-range-slider
              type="time"
              ariaLabel="labal.departureTime"
              handlePoint="two"
              [valueMin]="this.TIME_WINDOW_MIN"
              [valueMax]="this.TIME_WINDOW_MAX"
              [stepGrid]="this.TIME_WINDOW_STEP"
              [disabled]="oldDomesticAswSearchFlag"
              unitFront=""
              unitBack=""
              [formControl]="this.formControlDepartureTimeWindow"
            ></asw-range-slider>
          </div>
        </div>
        <!-- //[option 左側] -->

        <!-- [option 右側] -->
        <div class="p-input-list-area02__block-item">
          <div class="p-input-list-area02__block-item-box">
            <h3 class="p-input-list-area02__block-item-title" [innerHTML]="'label.returnPath' | staticMsg"></h3>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <h4 class="p-input-list-area02__block-item-lv2title" [innerHTML]="'labal.departureTime' | staticMsg"></h4>
            <asw-range-slider
              type="time"
              handlePoint="two"
              ariaLabel="labal.departureTime"
              [valueMin]="this.TIME_WINDOW_MIN"
              [valueMax]="this.TIME_WINDOW_MAX"
              [stepGrid]="this.TIME_WINDOW_STEP"
              [disabled]="oldDomesticAswSearchFlag"
              unitFront=""
              unitBack=""
              [formControl]="this.formControlReturnTimeWindow"
            ></asw-range-slider>
          </div>
        </div>
        <!-- //[option 右側] -->
      </div>
    </div>
  </div>
</div>
<!-- //[option] -->

<!-- [2段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <!-- 有償/特典指定プルダウン -->
        <asw-select
          label="{{ 'label.all.fareType' | staticMsg }}"
          [selected]="this.selectedAwardOption"
          (change$)="getOutputAwardOption($event)"
          id="roundtrip-select-award"
        >
          <ng-container *ngFor="let option of this.awardOptions">
            <option value="{{ option.value }}">
              {{ option.textContent }}
            </option>
          </ng-container>
        </asw-select>
      </div>
      <div class="p-input-list-area01__block-item">
        <ng-container *ngIf="this.isFareTypeShow">
          <asw-fare-type-selector
            [selected]="this.selectedFareOptionType"
            [selectedAwardOption]="this.selectedAwardOption"
            [isEnabled]="this.isEnabled"
            [isJapanOnlyFlag]="this.isJapanOnlyFlag"
            (apply$)="getOutputFareOptionType($event)"
          >
          </asw-fare-type-selector>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- //[2段目] -->
